import { FormProvider, useForm } from 'react-hook-form';
import Modal from '@/components/modal/Modal.tsx';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { debugZodResolver } from '@/lib/debugZodResolver.ts';
import {
  insuranceSchema,
  InsuranceFormData,
  insuranceDefaultValues,
} from '@/features/dashboard/insurances/schemas/insuranceSchema.ts';
import useCreateInsurance from '@/features/dashboard/insurances/hooks/useCreateInsurance.ts';
import InsuranceForm from '@/features/dashboard/insurances/components/InsuranceForm.tsx';

const CreateInsuranceModal = ({ onClose }: { onClose: () => void }) => {
  const createMutation = useCreateInsurance();

  const methods = useForm<InsuranceFormData>({
    resolver: debugZodResolver(insuranceSchema),
    defaultValues: insuranceDefaultValues,
  });

  const { handleSubmit } = methods;

  const onSubmit = (data: InsuranceFormData) => {
    createMutation.mutate(data, { onSuccess: () => onClose() });
  };

  return (
    <Modal onClose={onClose} isDirty={methods.formState.isDirty}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader title="Dodaj ubezpieczenie" onClose={onClose} />
          <ModalContent>
            <InsuranceForm />
          </ModalContent>
          <ModalFooter>
            <ActionButton
              tone="ghost"
              size="sm"
              type="button"
              onClick={onClose}
            >
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={createMutation.isPending}
            >
              Dodaj ubezpieczenie
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default CreateInsuranceModal;
